var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),schema = locals_.schema,record = locals_.record;
var jade_indent = [];
buf.push("\n<p class=\"caution\">Delete " + (jade.escape((jade_interp = schema.name.toLowerCase()) == null ? '' : jade_interp)) + " id  <code>#" + (jade.escape((jade_interp = record.id) == null ? '' : jade_interp)) + "</code></p>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}